import axios from 'axios';
import authHeader from '../auth-header';

import tokenHeader from '../token-header';

// const API_URL = 'https://localhost:9090/api/all/';
import baseUrl from '../base-url';

const API_URL = baseUrl() + "/api/all/";

const getDataKeanggotaan = 'data-keanggotaan';
const getDataPaktaIntegritas = 'data-pakta-integritas';
const getDataKeanggotaanUnverif = 'data-keanggotaan-unverif';

const getDataAnggotaPeriode = 'data-keanggotaan-filter-tahun-tanggal';
const getDataAnggotaKategori = 'data-keanggotaan-filter-kategori';
const getDataAnggota = 'data-keanggotaan/';
const getDataAnggotaAp = 'data-keanggotaan/data-anggota/get-anggota-ap/';
const getDataDiri = 'data-keanggotaan/data-diri/'
const getDokumenPendukungPeserta = 'data-keanggotaan/dokumen-pendukung-peserta-dan-master/'
const putDataDiri = 'data-keanggotaan/data-diri/'
const putDataAnggota = 'data-keanggotaan/data-anggota/'
const verifikasiDataDiri = 'data-keanggotaan/data-diri/verifikasi'
const verifikasiDataKeanggotaan = 'data-keanggotaan/data-anggota/verifikasi'
const verifikasiDataDokumen = 'data-keanggotaan/data-dokumen-pendukung/verifikasi'
const getDataMasterDokumenPendukung = 'data-keanggotaan/master-dokumen-pendukung'
const postMessage = 'send-standar-message'
const getAllDataAnggota = 'data-keanggotaan-name-only'

const getCalonAnggota = 'calon-data-keanggotaan';
const putDataAnggotaUrl = 'data-anggota/';
const deleteDataAnggota = 'data-anggota/';
const postDataAnggota = 'data-anggota'

const deleteDataKeanggotaan = 'data-anggota/';
const generateNoAnggota = 'generate-no-anggota/';

const exportVerifAnggota = 'data-keanggotaan-export-verif'
const exportUnverifAnggota = 'data-keanggotaan-export-unverif'
// const postDataKeanggotaanUrl = 'data-keanggotaan';
// const putDataKeanggotaan = 'data-keanggotaan/';

class DataKeanggotaanService {
    ubahStatusAnggotaExcel(formData) {
        var form = new FormData();
        if(typeof formData.file !== 'undefined' || formData.file !== undefined ) {
            form.append("file",formData.file); 
        }
        return axios
        .put(
            API_URL + 'data-keanggotaan/import-anggota-ubah-status',
            form, 
            { headers: { 'Content-Type': 'multipart/form-data','Authorization' : tokenHeader() } }
        );
    }

    getAnggotaAp(idKategoriAnggota) {
        return axios.get(
            API_URL + getDataAnggotaAp + idKategoriAnggota,
            {
                headers: authHeader()
            }
        )
    }

    getDataAnggotaPeriodeTahunKategori(tahun, kategori) {
        return axios.get(
            API_URL + getDataAnggotaPeriode + '?tahun=' + tahun + '&kategori=' + kategori,
            {
                headers: authHeader()
            }
        );
    }

    getDataAnggotaKategori(kategori) {
        return axios.get(
            API_URL + getDataAnggotaKategori + '?kategori=' + kategori,
            {
                headers: authHeader()
            }
        );
    }

    generateNoAnggota(idUser) {
        return axios.get(
            API_URL + generateNoAnggota + idUser,
            {
                headers: authHeader()
            }
        )
    }
    
    getAllDataAnggotaUnverif() {
        return axios.get(
            API_URL + getDataAnggotaKategori + '?statusAnggota=unverif',
            {
                headers: authHeader()
            }
        );
    }
    
    getAllDataAnggotaSemua() {
        return axios.get(
            API_URL + getDataAnggotaKategori + '?statusAnggota=all',
            {
                headers: authHeader()
            }
        );
    }

    getAllDataAnggota()
    {
        return axios.get(
            API_URL + getAllDataAnggota,
            {
                headers: authHeader()
            }
        );
    }

    getDataKeanggotaan(currentPage,pageSize,filter, filterKategori) {
        return axios.get(
            API_URL + getDataKeanggotaan + '?pageNo=' + currentPage + '&pageSize='+pageSize + '&filter='+filter +'&filterKategori=' + filterKategori,
            {
                headers: authHeader()
            }
        );
    }

    getDataPaktaIntegritas() {
        return axios.get(
            API_URL + getDataPaktaIntegritas,
            {
                headers: authHeader()
            }
        );
    }

    getDataKeanggotaanUnverif(currentPage,pageSize,filter, filterKategori) {
        return axios.get(
            API_URL + getDataKeanggotaanUnverif + '?pageNo=' + currentPage + '&pageSize='+pageSize + '&filter='+filter +'&filterKategori=' + filterKategori,
            {
                headers: authHeader()
            }
        );
    }

    getCalonAnggota(currentPage,pageSize,filter) {
        return axios.get(
            API_URL + getCalonAnggota + '?pageNo=' + currentPage + '&pageSize='+pageSize + '&filter='+filter,
            {
                headers: authHeader()
            }
        );
    }

    getDataDiri(idUser) {
        return axios.get(
            API_URL + getDataDiri + idUser,
            {
                headers: authHeader()
            }
        );
    }

    getDataAnggota(idUser) {
        return axios.get(
            API_URL + getDataAnggota + idUser,
            {
                headers: authHeader()
            }
        );
    }

    getDataMasterDokumenPendukung() {
        return axios.get(
            API_URL + getDataMasterDokumenPendukung,
            {
                headers: authHeader()
            }
        );
    }

    getDokumenPendukungPeserta(idUser) {
        return axios.get(

            API_URL + getDokumenPendukungPeserta + idUser,
            {
                headers: authHeader()
            }
        );
    }


    verifikasiDataDiri(formData) {
        return axios
            .post(
                API_URL + verifikasiDataDiri,
                formData,
                { headers: authHeader() }
            );
    }

    verifikasiDataDokumen(formData) {
        var data = {
            idDokumenPendukungPeserta: formData.idDokumenPendukungPeserta,
            statusUpload: formData.statusUpload,
            alasan : formData.alasan
        }
        return axios.post(API_URL + verifikasiDataDokumen, data, {
            headers: authHeader()
        });
    }

    verifikasiDataDokumenAseanCpa(formData) {
        var data = {
            idDokumenPendukungPeserta: formData.idDokumenPendukungPeserta,
            statusUpload: formData.statusUpload,
            alasan: formData.alasan,
        }
        return axios.post(API_URL + verifikasiDataDokumen, data, {
            headers: authHeader()
        });
    }

    verifikasiDataKeanggotaan(formData) {
        return axios
            .post(
                API_URL + verifikasiDataKeanggotaan,
                formData,
                { headers: authHeader() }
            );
    }

    updateDataDiri(idUser, formData) {
        return axios
            .put(
                API_URL + putDataDiri + idUser,
                formData,
                { headers: authHeader() }
            );
    }

    updateDataAnggota(idUser, formData) {
        return axios
            .put(
                API_URL + putDataAnggota + idUser,
                formData,
                { headers: authHeader() }
            );
    }

    postDataKeanggotaan(formData) {
        return axios
            .post(
                API_URL + postDataKeanggotaanUrl,
                formData,
                { headers: authHeader() }
            );
    }

    putDataKeanggotaan(formData) {
        var headers = authHeader();

        return axios
            .put(
                API_URL + putDataKeanggotaan + formData.idDataKeanggotaan, formData,
                { headers: authHeader() }
            );
    }
    putDataAnggotaUrl(formData) {  
        if (typeof formData.password == 'undefined' || formData.password == undefined) {
            formData.password = "";
        }
        return axios
            .put(
                API_URL + putDataAnggotaUrl + formData.id_user, formData,
                { headers: authHeader() }
            );
    }

    deleteDataAnggota(formData) {
        var headers = authHeader();

        return axios
            .delete(
                API_URL + deleteDataAnggota + formData.id_user,
                { headers: authHeader() }
            );
    }

    deleteDataKeanggotaan(formData) {
        var headers = authHeader();

        return axios
            .delete(
                API_URL + deleteDataKeanggotaan + formData.idDataKeanggotaan,
                { headers: authHeader() }
            );
    }

    postSendMessage(formEmail) {
        var headers = authHeader();
        var form = new FormData();
        form.append("to", formEmail.to);
        form.append("subject", formEmail.subject);
        form.append("text", formEmail.text);
        if (typeof formEmail.attacment !== 'undefined') {
            form.append('attacment', formEmail.attacment);
        }
        return axios
            .post(
                API_URL + postMessage,
                form,
                { headers: { 'Content-Type': 'multipart/form-data', 'Authorization': tokenHeader() } }
            );
    }

    postDataAnggota(formData) {

        return axios
        .post(
            API_URL + postDataAnggota,
            formData,
            { headers: authHeader() }
        );
    }

    exportVerifAnggota() {
        return axios.get(API_URL + exportVerifAnggota, {
            headers: authHeader(),
            responseType: 'blob',        
        });
    }

    exportUnverifAnggota() {
        return axios.get(API_URL + exportUnverifAnggota, {
            headers: authHeader(),
            responseType: 'blob',
        });
    }

}

export default new DataKeanggotaanService();